import { config } from '../config'
import { GetRecentContentLibrary, UpdateDocument } from '../types'
import { requestsV2 } from '../utils'

export const TemplateContentLibraryService = {
  addToContentLibrary: (params: UpdateDocument) => {
    return requestsV2(config.PROPOSAL_SERVICE_URL).post(
      '/templates/content-library/add',
      params
    )
  },
  fetchRecentContentFromContentLibrary: (params: GetRecentContentLibrary) => {
    return requestsV2(config.PROPOSAL_SERVICE_URL).get(
      '/templates/content-library/recent',
      {
        params,
      }
    )
  },
}
